(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.MeinKofferExpertColorMix) return;

  const selector = '[data-mix-color-site="meinkofferexpert"]';
  const mode = 'barcelona';
  const configurations = new WeakMap();
  const listStates = new WeakMap();
  const manualSelections = new WeakMap();
  const previousColors = new Map();
  const currentColors = new Map();
  let scheduled = false;
  let instance = 0;

  function colorKey(value) {
    return String(value).normalize('NFKC').trim().replace(/\s+/g, ' ').toLocaleLowerCase();
  }

  function configuration(card) {
    if (!configurations.has(card)) {
      try {
        const config = JSON.parse(card.getAttribute('data-mix-color-data'));
        const suffix = '-mix-' + (++instance);
        card.querySelectorAll(swatchSelector()).forEach(input => {
          const id = input.id;
          card.querySelectorAll('label').forEach(label => {if (label.htmlFor === id) label.htmlFor = id + suffix;});
          if (id) input.id = id + suffix;
          input.name += suffix;
        });
        configurations.set(card, config);
      } catch (error) {
        configurations.set(card, null);
      }
    }
    return configurations.get(card);
  }

  function storageKey(productId) {
    return 'meinkofferexpert-color-v2:' + location.pathname + ':' + productId;
  }

  function previousColor(productId) {
    if (!previousColors.has(productId)) {
      let value = null;
      try { value = sessionStorage.getItem(storageKey(productId)); } catch (error) {}
      previousColors.set(productId, value);
    }
    return previousColors.get(productId);
  }

  function remember(productId, color) {
    previousColor(productId);
    currentColors.set(productId, colorKey(color));
    try { sessionStorage.setItem(storageKey(productId), colorKey(color)); } catch (error) {}
  }

  function allocate(cards, history) {
    const entries = cards.map((card, position) => {
      const config = configuration(card);
      const manual = manualSelections.get(card);
      const variants = manual ? [manual] : (config?.variants || []).filter(variant => variant.available && variant.matchesFilter && variant.image);
      return {card, config, variants, position};
    }).filter(entry => entry.variants.length);
    const colors = [...new Set(entries.flatMap(entry => entry.variants.map(variant => colorKey(variant.color))))];
    const source = 0;
    const colorStart = 1 + entries.length;
    const sink = colorStart + colors.length;
    const graph = Array.from({length: sink + 1}, () => []);

    function edge(from, to, capacity, cost, variant = null) {
      const forward = {to, reverse: graph[to].length, capacity, cost, variant};
      const backward = {to: from, reverse: graph[from].length, capacity: 0, cost: -cost};
      graph[from].push(forward);
      graph[to].push(backward);
    }

    entries.forEach((entry, index) => {
      edge(source, index + 1, 1, 0);
      const previous = previousColor(entry.config.productId);
      const current = currentColors.get(entry.config.productId);
      const recent = history.slice(Math.max(0, history.length - 5 + entry.position));
      entry.variants.forEach(variant => {
        const key = colorKey(variant.color);
        const cost = (key === previous ? 10000 : 0) + (current && key !== current ? 1000 : 0) + (recent.includes(key) ? 500 : 0) + Math.floor(Math.random() * 100);
        edge(index + 1, colorStart + colors.indexOf(key), 1, cost, variant);
      });
    });

    colors.forEach((color, index) => {
      for (let count = 0; count < entries.length; count++) {
        edge(colorStart + index, sink, 1, count === 0 ? 0 : 1000000 + count * 100);
      }
    });

    for (let flow = 0; flow < entries.length; flow++) {
      const distance = Array(graph.length).fill(Infinity);
      const path = Array(graph.length);
      distance[source] = 0;
      for (let pass = 0; pass < graph.length - 1; pass++) {
        let changed = false;
        graph.forEach((edges, from) => {
          edges.forEach((item, index) => {
            if (item.capacity > 0 && distance[from] + item.cost < distance[item.to]) {
              distance[item.to] = distance[from] + item.cost;
              path[item.to] = [from, index];
              changed = true;
            }
          });
        });
        if (!changed) break;
      }
      if (!Number.isFinite(distance[sink])) break;
      for (let node = sink; node !== source;) {
        const [from, index] = path[node];
        const item = graph[from][index];
        item.capacity--;
        graph[node][item.reverse].capacity++;
        node = from;
      }
    }

    return entries.map((entry, index) => ({
      card: entry.card,
      variant: graph[index + 1].find(item => item.variant && item.capacity === 0)?.variant
    })).filter(selection => selection.variant);
  }

  function swatchSelector() {
    return mode === 'barcelona' ? '.js-color-swatches input[type="radio"]' : mode === 'hero' ? '[data-variants] input[type="radio"]' : '.color-swatch__radio';
  }

  function variantForInput(card, input) {
    return configuration(card)?.variants.find(variant => colorKey(variant.color) === colorKey(input.value));
  }

  function updateImage(image, details, className) {
    if (mode === 'hero' && image && image.getAttribute('data-image-id') !== details.id) {
      const replacement = image.cloneNode(false);
      image.replaceWith(replacement);
      image = replacement;
    }
    if (!image) {
      image = document.createElement('img');
      image.className = className;
    }
    image.setAttribute('data-image-id', details.id);
    image.setAttribute('data-media-id', details.mediaId || details.id);
    image.setAttribute('data-src', details.url);
    image.setAttribute('data-widths', details.widths.join(', '));
    image.width = details.width;
    image.height = details.height;
    image.alt = details.alt;
    if (mode === 'hero') image.classList.remove('lazy', 'lazyload', 'animate-pulse');
    image.style.objectPosition = details.focalPoint;
    image.loading = 'lazy';
    const widths = details.widths.filter(width => width <= details.width);
    if (widths.length) image.srcset = widths.map(width => details.template.replace('{width}', width) + ' ' + width + 'w').join(', ');
    else image.removeAttribute('srcset');
    image.src = details.url;
    return image;
  }

  function productLinks(card, variant) {
    const productPath = new URL(configuration(card).url, location.href).pathname;
    card.querySelectorAll('a[href], quick-buy-popover[href], quick-buy-drawer[href]').forEach(link => {
      const href = link.getAttribute('href');
      if (!href || new URL(href, location.href).pathname !== productPath) return;
      const oldUrl = new URL(href, location.href);
      const nextUrl = new URL(variant.url, location.href);
      if (oldUrl.searchParams.has('view')) nextUrl.searchParams.set('view', oldUrl.searchParams.get('view'));
      if (oldUrl.hash && !oldUrl.hash.startsWith('#Image')) nextUrl.hash = oldUrl.hash;
      link.setAttribute('href', nextUrl.pathname + nextUrl.search + nextUrl.hash);
    });
    card.querySelectorAll('[data-product-url]').forEach(button => button.setAttribute('data-product-url', variant.url));
    card.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach(input => {input.value = variant.id;});
  }

  function applyBarcelona(card, variant, config) {
    const wrapper = card.querySelector('.js-color-swatches-link');
    const old = wrapper?.querySelector('.media--first');
    if (old && variant.image) {
      updateImage(old, variant.image, old.className);
      const alternate = wrapper.querySelector('.media--second');
      if (config.secondary && variant.alternate) {
        const image = updateImage(alternate, variant.alternate, old.className.replace('media--first', 'media--second'));
        if (!image.parentElement) wrapper.append(image);
      } else alternate?.remove();
    }
    const sku = card.querySelector('.card__sku');
    if (sku) {
      const label = sku.querySelector('.visually-hidden');
      sku.replaceChildren();
      if (label) sku.append(label);
      sku.append(document.createTextNode(' ' + (variant.sku || '')));
    }
    card.querySelectorAll('product-form button[type="submit"]').forEach(button => {button.disabled = !variant.available;});
  }

  function applyFocal(card, variant, config) {
    const aspect = card.querySelector('.product-item__aspect-ratio');
    if (!aspect || !variant.image) return;
    let image = [...aspect.querySelectorAll('.product-item__primary-image')].find(item => item.getAttribute('data-media-id') === (variant.image.mediaId || variant.image.id));
    image = updateImage(image, variant.image, 'product-item__primary-image');
    if (!image.parentElement) aspect.prepend(image);
    aspect.querySelectorAll('.product-item__primary-image').forEach(item => {
      item.toggleAttribute('hidden', item !== image);
    });
    aspect.style.setProperty('--aspect-ratio', variant.image.ratio);
    aspect.style.paddingBottom = 100 / variant.image.ratio + '%';
    const alternate = aspect.querySelector('.product-item__secondary-image');
    if (config.secondary && variant.alternate) {
      const secondary = updateImage(alternate, variant.alternate, 'product-item__secondary-image');
      if (!secondary.parentElement) aspect.append(secondary);
    } else alternate?.remove();
    card.querySelector('.product-item__image-wrapper')?.classList.toggle('product-item__image-wrapper--multiple', Boolean(config.secondary && variant.alternate));
    if (card.primaryImageList) card.primaryImageList = [...aspect.querySelectorAll('.product-item__primary-image')];
  }

  function applyHero(card, variant, config) {
    const main = card.querySelector('.main_image');
    const original = main?.querySelector('img');
    if (!original || !variant.image) return;
    updateImage(original, variant.image, original.className);
    main.classList.remove('hidden');
    main.classList.toggle('main_image_hover', Boolean(config.secondary && variant.alternate));
    const gallery = card.querySelector('[data-variant-images]');
    gallery?.classList.add('hidden');
    gallery?.querySelectorAll('[variant-id]').forEach(item => item.classList.add('hidden'));
    let secondary = card.querySelector('.secondary_image');
    if (config.secondary && variant.alternate) {
      if (!secondary) {
        secondary = document.createElement('div');
        secondary.className = 'secondary_image';
        secondary.setAttribute('data-component', 'component');
        main.after(secondary);
      }
      secondary.classList.remove('hidden');
      const image = updateImage(secondary.querySelector('img'), variant.alternate, original.className);
      if (!image.parentElement) secondary.append(image);
    } else secondary?.remove();
  }

  function apply(card, variant) {
    const config = configuration(card);
    productLinks(card, variant);
    let selectedInput = false;
    card.querySelectorAll(swatchSelector()).forEach(input => {
      const selected = !selectedInput && colorKey(input.value) === colorKey(variant.color);
      input.checked = selected;
      if (selected) {
        selectedInput = true;
        input.setAttribute('data-variant-link', variant.url);
        input.setAttribute('data-variant-id', variant.id);
        input.setAttribute('data-vid', variant.id);
        if (variant.image) input.setAttribute('data-variant-featured-media', variant.image.mediaId || variant.image.id);
      }
    });
    if (mode === 'barcelona') applyBarcelona(card, variant, config);
    else if (mode === 'focal') applyFocal(card, variant, config);
    else applyHero(card, variant, config);
    card.setAttribute('data-mix-selected-color', variant.color);
    remember(config.productId, variant.color);
  }

  function refresh() {
    scheduled = false;
    const lists = new Map();
    document.querySelectorAll(selector).forEach(card => {
      if (!configuration(card)) return;
      const list = card.closest('.collection-product-list, .product-list__inner, .product-list, #product-grid, [data-product-list], .collection__products, .product-grid, .swiper-wrapper, .splide__list, .grid') || card.closest('[id^="shopify-section-"], [data-section-id]') || card.parentElement;
      if (!lists.has(list)) lists.set(list, []);
      lists.get(list).push(card);
    });
    lists.forEach((cards, list) => {
      const old = listStates.get(list);
      if (old && old.length === cards.length && old.every((card, index) => card === cards[index])) return;
      listStates.set(list, cards);
      const history = [];
      for (let offset = 0; offset < cards.length; offset += 6) {
        const block = cards.slice(offset, offset + 6);
        const selections = allocate(block, history);
        selections.forEach(selection => apply(selection.card, selection.variant));
        block.forEach(card => {
          const color = card.getAttribute('data-mix-selected-color');
          history.push(color ? colorKey(color) : null);
        });
      }
    });
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(refresh);
  }

  window.MeinKofferExpertColorMix = {refresh: schedule};
  function selectManually(event) {
    if (!(event.target instanceof Element) || !event.target.matches(swatchSelector())) return;
    const card = event.target.closest(selector);
    if (!card) return;
    const variant = variantForInput(card, event.target);
    if (!variant) return;
    manualSelections.set(card, variant);
    apply(card, variant);
    if (mode !== 'hero') event.stopImmediatePropagation();
  }

  document.addEventListener('change', selectManually, true);
  if (mode === 'barcelona') document.addEventListener('click', selectManually, true);
  if (mode === 'hero') document.addEventListener('change', event => {
    const card = event.target.closest?.(selector);
    if (card && event.target.matches(swatchSelector())) {
      const variant = variantForInput(card, event.target);
      if (variant) apply(card, variant);
    }
  });

  const observer = new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector))))) schedule();
  });
  observer.observe(document.documentElement, {childList: true, subtree: true});
  document.addEventListener('shopify:section:load', schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, {once: true});
  else refresh();
})();
  } catch(e) { console.error(e); }
})();

})();
